import Swiper, { Pagination } from 'swiper';

class SliderTypeGrid {
  constructor(rootElement) {
    this.rootElement = rootElement;

    this.findElements();
    this.initSlider();
  }

  findElements() {
    this.sliderElement = this.rootElement.querySelector('[data-entity="slider"]');
    this.paginationElement = this.rootElement.querySelector('[data-entity="pagination"]');
  }

  initSlider() {
    this.slider = new Swiper(this.sliderElement, {
      modules: [Pagination],

      enabled: true,
      slidesPerView: 1,
      spaceBetween: 24,
      autoHeight: true,

      pagination: {
        el: this.paginationElement,
        type: 'bullets',
        dynamicBullets: true,
        dynamicMainBullets: 4,
      },

      breakpoints: {
        768: {
          enabled: false,
        },
      },
    });
  }
}

export default SliderTypeGrid;
